import { get } from 'lodash';
import React from 'react';
import { KOSTEN_ARTEN, KOSTEN_POSITION, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import { enumT } from 'src/utils/helper';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import {
	checkIfAllPositionIsEditable,
	checkIfAnyPositionNachKostenArtHasComment,
	checkIfHasComment,
	checkIfProjektDatenHasComment,
} from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import { TreeStructureAntragAbschlussSeiteGlobal } from '../../global-structure/abschluss-seite/TreeStructureAbschlussSeiteGlobal';
import { TreeStructureAllgemeinHinweisGlobal } from '../../global-structure/allgemeinen-hinweis/TreeStructureAllgemeinHinweisGlobal';
import { TreeStructureAnlagenGlobal } from '../../global-structure/anlagen/TreeStructureAnlagenGlobal';
import { TreeStructureAntragBescheidGlobal } from '../../global-structure/antrag-bescheid/TreestructureAntragBescheidGlobal';
import { TreeStructureAntragstellerGlobal } from '../../global-structure/antragstellerin/TreeStructureAntragstellerGlobal';
import { TreeStructureDeMinimisGlobal } from '../../global-structure/de-minimis/TreeStructureDeMinimisGlobal';
import { TreeStructureErklaerungGlobal } from '../../global-structure/erklaerung/TreeStructureErklaerungGlobal';
import { TreeStructureAntragFinanzierungsPlanGlobal } from '../../global-structure/finanzierung-plan-antrag/TreeStructureAntragFinanzierungsPlanGlobal';
import { TreeStructureSelbstErklaerungRUSGlobal } from '../../global-structure/rus-erklaerung/TreeStructureSelbstErklaerungRUSGlobal';
import { TreeStructureSelbstErklaerungKMUGlobal } from '../../global-structure/selbst-erklaerung-kmu/TreeStructureSelbstErklaerungKMUGlobal';
import { TreeStructureSelbstErklaerungBeihilferelevanzGlobal } from '../../global-structure/beihilferelevanz-erklaerung/TreeStructureSelbstErklaerungBeihilferelevanzGlobal';
import { TreeStructureAntragVerbundpartnerGlobal } from '../../global-structure/verbundpartner-antrag/TreeStructureAntragVerbundpartnerGlobal';
import { TreeStructureAntragVorzeitigerMassnahme } from '../../global-structure/vorzeitige-massnahme/TreeStructureVorzeitigeMassnahmeGlobal';
import { TreeStructureZeitplanungGlobal } from '../../global-structure/zeitplanung/TreeStructureZeitplanungGlobal';
import ProjektDatenAntragLogMob, { getFormStrucProjektDatenAntragLogMob } from './content/ProjektDatenAntragLogMob';
import EinnahmeUebersichtAntragLogMob from './content/einnahme/EinnahmeUebersichtAntragLogMob';
import { GetEigenmittelAntragLogMob } from './content/einnahme/GetEigenmittelAntragLogMob';
import { GetPersonalKostenAntragLogMob } from './content/personalkosten/GetPersonalKostenAntragLogMob';
import PersonalKostenUebersichtAntragLogMob from './content/personalkosten/PersonalKostenUebersichtAntragLogMob';
import AusgangssituationAntragLogMob, {
	getFormStrucAusgangssituationAntragLogMob,
} from './content/projektbeschreibung/AusgangssituationAntragLogMobAntragLogMob';
import BeschreibungAntragLogMob, { getFormStrucBeschreibungAntragLogMob } from './content/projektbeschreibung/BeschreibungAntragLogMob';
import DurchfuehrungHOLMAntragLogMob, {
	getFormStrucDurchfuehrungHOLMAntragLogMob,
} from './content/projektbeschreibung/DurchfuehrungHOLMAntragLogMob';
import EntwicklungsstandAntragLogMob, {
	getFormStrucEntwicklungsstandAntragLogMob,
} from './content/projektbeschreibung/EntwicklungsstandAntragLogMob';
import InnovationAntragLogMob, { getFormStrucInnovationAntragLogMob } from './content/projektbeschreibung/InnovationAntragLogMob';
import KommunikationsAntragLogMob, { getFormStrucKommunikationsAntragLogMob } from './content/projektbeschreibung/KommunikationsAntragLogMob';
import QualifikationAntragLogMob, { getFormStrucQualifikationAntragLogMob } from './content/projektbeschreibung/QualifikationAntragLogMob';
import SWOTAntragLogMob, { getFormStrucSWOTAntragLogMob } from './content/projektbeschreibung/SWOTAntragLogMob';
import WettbewerbsanalyseAntragLogMob, {
	getFormStrucWettbewerbsanalyseAntragLogMob,
} from './content/projektbeschreibung/WettbewerbsanalyseAntragLogMob';
import { GetSachkostenAntragLogMob } from './content/sachkosten/GetSachkostenAntragLogMob';
import SachkostenUebersichtAntragLogMob from './content/sachkosten/SachkostenUebersichtAntragLogMob';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

export const TreeStructureAntragLogMob = (
	application: any,
	readOnly: boolean,
	kostenKategoriesGroup: any,
	allgemeineHinweiseKMU: any,
	allgemeineHinweiseDeminimis: any,
	allgemeineHinweiseRUS: any,
	allgemeineHinweiseBeihilferelevanz: any,
) => {
	const hasCommentProjektdaten = checkIfProjektDatenHasComment(readOnly, application);
	const isKostenEditable = checkIfAllPositionIsEditable(readOnly, application);

	let treeNodes: TreeNodeType[] = [
		// Allgemine Hinweise Global
		...TreeStructureAllgemeinHinweisGlobal(application),
		// Projektdaten
		{
			label: 'Projektdaten',
			content: <ProjektDatenAntragLogMob hasComment={hasCommentProjektdaten} />,
			formStruc: getFormStrucProjektDatenAntragLogMob(application),
			hasComment: hasCommentProjektdaten,
		},
		// Antragsteller Global
		...TreeStructureAntragstellerGlobal(application, readOnly),
		// Partner Global
		...TreeStructureAntragVerbundpartnerGlobal(application, readOnly),
		// Selbsterlärung-KMU Global
		...TreeStructureSelbstErklaerungKMUGlobal(application, readOnly, allgemeineHinweiseKMU),
		// Beihilferelevanz-Erklärungen Global
		...TreeStructureSelbstErklaerungBeihilferelevanzGlobal(application, readOnly, allgemeineHinweiseBeihilferelevanz),
		// RUS-Erklärungen Global
		...TreeStructureSelbstErklaerungRUSGlobal(application, readOnly, allgemeineHinweiseRUS),
		// Deminismis-Selbsterklärung Global
		...TreeStructureDeMinimisGlobal(application, readOnly, allgemeineHinweiseDeminimis),
		// Projektbeschreibung
		...ProjektbeschreibungStructure(application, readOnly),
		// Kosten
		...PersonalKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...SachKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...EinnahmeStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		// Finanzierungsplan Global
		...TreeStructureAntragFinanzierungsPlanGlobal(application, isKostenEditable),
		// Zeitplanung Global
		...TreeStructureZeitplanungGlobal(application, readOnly),
		// Anlagen und Erklärungen Global
		...TreeStructureAnlagenGlobal(application, readOnly),
		...TreeStructureErklaerungGlobal(application, readOnly),
		// Vorzeitiger Massnahme Global
		...TreeStructureAntragVorzeitigerMassnahme(application, readOnly),
		// Abschluss Global
		...TreeStructureAntragAbschlussSeiteGlobal(application, readOnly),
		// Bescheid Global
		...TreeStructureAntragBescheidGlobal(application),
	];

	return treeNodes;
};

const ProjektbeschreibungStructure = (application: any, readOnly: boolean) => {
	const hasCommentBeschreibungDesVorhabens = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Projektziel_Pruefstatus.path,
	);
	const hasCommentAusgangssituation = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Stand_Der_Technik_Pruefstatus.path,
	);
	const hasCommentEntwicklungsstand = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Entwicklungsstand_Pruefstatus.path,
	);
	const hasCommentInnovation = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Darlegung_Innovation_Pruefstatus.path,
	);
	const hasCommentWettbewerbAnalyse = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Wirtschaftliche_Verwertung_Pruefstatus.path,
	);
	const hasCommentSWOT = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_SWOT_Pruefstatus.path,
	);
	const hasCommentDurchfuehrungHOLM = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Durchfuehrung_HOLM_Pruefstatus.path,
	);
	const hasCommentKommunikation = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Oeffentlichkeitsarbeit_Pruefstatus.path,
	);
	const hasCommentQualifikation = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Kompetenzen_Pruefstatus.path,
	);

	let nodes: TreeNodeType[] = [
		{
			label: 'Projektbeschreibung',
			content: <ApplicationHeading title='Projektbeschreibung' description={PLATZHALTER_TEXT} />,
			hasComment:
				hasCommentBeschreibungDesVorhabens ||
				hasCommentAusgangssituation ||
				hasCommentEntwicklungsstand ||
				hasCommentInnovation ||
				hasCommentWettbewerbAnalyse ||
				hasCommentSWOT ||
				hasCommentDurchfuehrungHOLM ||
				hasCommentKommunikation ||
				hasCommentQualifikation,
			children: [
				{
					label: 'Beschreibung des Vorhabens / Erwartetes Projektziel',
					content: <BeschreibungAntragLogMob hasComment={hasCommentBeschreibungDesVorhabens} />,
					formStruc: getFormStrucBeschreibungAntragLogMob(application),
					hasComment: hasCommentBeschreibungDesVorhabens,
				},
				{
					label: 'Ausgangssituation, Stand der Technik, Bedarf nach neuen Lösungen',
					content: <AusgangssituationAntragLogMob hasComment={hasCommentAusgangssituation} />,
					formStruc: getFormStrucAusgangssituationAntragLogMob(application),
					hasComment: hasCommentAusgangssituation,
				},
				{
					label: 'Bereits geleistete Vorarbeiten / gegenwärtiger Entwicklungsstand; Schutzrechtssituation / Ergebnis einer aktuellen Patentrecherche',
					content: <EntwicklungsstandAntragLogMob hasComment={hasCommentEntwicklungsstand} />,
					formStruc: getFormStrucEntwicklungsstandAntragLogMob(application),
					hasComment: hasCommentEntwicklungsstand,
				},
				{
					label: 'Begründung des Innovations- und Exzellenzprofils des Projektes / Neuartigkeit der Technik / (Wissenschaftliche) Alleinstellungsmerkmale',
					content: <InnovationAntragLogMob hasComment={hasCommentInnovation} />,
					formStruc: getFormStrucInnovationAntragLogMob(application),
					hasComment: hasCommentInnovation,
				},
				{
					label: 'Markt- und Wettbewerbsanalyse / Verwertungspläne und -prognosen',
					content: <WettbewerbsanalyseAntragLogMob hasComment={hasCommentWettbewerbAnalyse} />,
					formStruc: getFormStrucWettbewerbsanalyseAntragLogMob(application),
					hasComment: hasCommentWettbewerbAnalyse,
				},
				{
					label: 'SWOT-Analyse',
					content: <SWOTAntragLogMob hasComment={hasCommentSWOT} />,
					formStruc: getFormStrucSWOTAntragLogMob(application),
					hasComment: hasCommentSWOT,
				},
				{
					label: 'Durchführungsort, Einbindung des HOLM',
					content: <DurchfuehrungHOLMAntragLogMob hasComment={hasCommentDurchfuehrungHOLM} />,
					formStruc: getFormStrucDurchfuehrungHOLMAntragLogMob(application),
					hasComment: hasCommentDurchfuehrungHOLM,
				},
				{
					label: 'Kommunikationsmaßnahmen / Art der Veröffentlichungen',
					content: <KommunikationsAntragLogMob hasComment={hasCommentKommunikation} />,
					formStruc: getFormStrucKommunikationsAntragLogMob(application),
					hasComment: hasCommentKommunikation,
				},
				{
					label: 'Qualifikation der eingebundenen Partner / Aufgaben & Verantwortlichkeiten / Verteilung entstehender Schutzrechte',
					content: <QualifikationAntragLogMob hasComment={hasCommentQualifikation} />,
					formStruc: getFormStrucQualifikationAntragLogMob(application),
					hasComment: hasCommentQualifikation,
				},
			],
		},
	];
	return nodes;
};
const PersonalKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Personalkosten)) {
		return [
			{
				label: enumT(KOSTEN_ARTEN.Personalkosten),
				content: <ApplicationHeading title={KOSTEN_ARTEN.Personalkosten} description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Personalkosten),
				children: GetPersonalKostenAntragLogMob(application, hasCommentAusgabenUndFinanzierung),
			},
			{
				label: 'Personalkosten Übersicht',
				content: <PersonalKostenUebersichtAntragLogMob />,
				isSummaryReport: true,
			},
		];
	}

	return [];
};
const SachKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Sachkosten)) {
		return [
			{
				label: enumT(KOSTEN_ARTEN.Sachkosten),
				content: <ApplicationHeading title={KOSTEN_ARTEN.Sachkosten} description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Sachkosten),
				children: GetSachkostenAntragLogMob(application, hasCommentAusgabenUndFinanzierung),
			},
			{
				label: 'Sachkosten Übersicht',
				content: <SachkostenUebersichtAntragLogMob />,
				isSummaryReport: true,
			},
		];
	}

	return [];
};
const EinnahmeStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(KOSTEN_ARTEN.Eigenmittel)) {
		return [
			{
				label: 'Eigen- und Drittmittel',
				content: <ApplicationHeading title='Eigen- und Drittmittel' description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Eigenmittel),
				children: GetEigenmittelAntragLogMob(application, hasCommentAusgabenUndFinanzierung),
			},
			{
				label: 'Eigen- und Drittmittel Übersicht',
				content: <EinnahmeUebersichtAntragLogMob />,
				isSummaryReport: true,
			},
		];
	}

	return [];
};
